module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-card",
    class: [_vm.cardClass, {
      'stat-centered': _vm.centrado
    }],
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "stat-indicator"
  }), _c('div', {
    staticClass: "stat-information"
  }, [_c('span', {
    staticClass: "stat-title"
  }, [_vm._v(_vm._s(_vm.titulo))]), (_vm.descripcion) ? _c('span', {
    staticClass: "stat-description"
  }, [_vm._v(_vm._s(_vm.descripcion))]) : _vm._e(), _c('div', {
    staticClass: "stat-footer"
  }, [_c('strong', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.cantidad))]), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "stat-link"
  }, [_vm._v("Ver detalle"), _c('span', {
    staticClass: "arrow"
  }, [_vm._v("→")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8409e774","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/dashboard/c_statCard.vue
// module id = 923
// module chunks = 0